export default __webpack_public_path__ + "static/laravel-icon-b80b8925beac921a43361e30cfc02926.svg";